import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setAuthentication } from "../store/Reducers";
import { useNavigate } from "react-router-dom";
import './Loginpage.css';
import "bootstrap/dist/css/bootstrap.min.css";
import Container from 'react-bootstrap/Container';
import { Row, Col } from "react-bootstrap";
import { Box } from '@mui/material';
import logo from '../assets/companyLogo.png';
import loginBanner from '../assets/loginBanner.jpg';
import { setLoading } from "../store/CommonSlice";
import { CustomMessage } from "../const/Spinner";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { login, passwordReset } from "../api/Services/commonServices";
import MailIcon from "@mui/icons-material/Mail";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { resetPassword } from "../api/Services/masterServie";
 
const ResetPass = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [email, setEmail] = useState("");
  const [oldpassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordReset = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !oldpassword || !password) {
      CustomMessage("Enter all details", "warning", enqueueSnackbar);
      return;
    }

    if (oldpassword === password) {
      CustomMessage("Old and new passwords cannot be same", "warning", enqueueSnackbar);
      return;
    }

    dispatch(setLoading(true));
    try {
      const response = await passwordReset({
        email,
        oldPassword: oldpassword,
        newPassword: password,
      });

      const { status } = response;

      if (status.code === 200) {
        CustomMessage("Password updated successfully. Please login", "success", enqueueSnackbar);

        // Reset all fields
        setEmail("");
        setOldPassword("");
        setPassword("");

        setTimeout(() => navigate("/"), 1200);
      } else {
        CustomMessage(status.message, "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  return (
    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center">
      <Container fluid className="px-0">
        <Row className="g-0">
          <Col className="col-12 col-md-6 px-5 d-flex align-items-center justify-content-center">
            <div className="col-lg-8">
              <div className="d-flex justify-content-center pb-0 menard-text">
                {/* <span className="d-none d-lg-block">MENARD</span> */}
                <Box component="a" href="/">
                  <Box component="img" src={logo} alt="Company Logo" sx={{ height: 60, width: 'auto' }} />
                </Box>
              </div>
              <div className="card mb-0 shadow-none border-0">
                <div className="card-body">
                  <div className="text-center mb-4">
                    <span className="small text-muted">
                        <LockResetOutlinedIcon className="me-1" sx={{ fontSize: 16 }} />
                        Change your password
                    </span>
                    </div>

                  <form className="row g-2 needs-validation login-form" onSubmit={handlePasswordReset}>
                    {/* Email Input */}
                    <div className="col-12">
                      {/* <label htmlFor="yourUsername" className="form-label">Email</label> */}
                      <div className="input-group position-relative mb-0">
                        <input
                          type="email"
                          name="username"
                          className="form-control input-with-icon bg-[#F3F1F0]"
                          id="yourUsername"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          placeholder="Enter your email"
                        />
                        <span
                          className=" position-absolute"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer", right: "10px", top: "50%", transform: "translateY(-50%)" }}
                        >
                          <MailIcon />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
          <label className="form-label">Old Password</label>
          <input
            type={showPassword ? "text" : "password"}
            className="form-control input-with-icon"
            value={oldpassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
            placeholder="Enter old password"
          />
        </div>

        {/* New Password */}
        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            type={showPassword ? "text" : "password"}
            className="form-control input-with-icon"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter new password"
          />
        </div>

        {/* Show password toggle */}
        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            onChange={() => setShowPassword(!showPassword)}
          />
          <label className="form-check-label">Show Passwords</label>
        </div>

                    {/* Login Button */}
                    <div className="col-12">
                      <button  className="btn btn-primary w-100 h-45">
                        Reset password
                      </button>
                    </div>
                  </form>
                 
                </div>
              </div>
            </div>
          </Col>
          <Col className="col-12 col-md-6">
            <img src={loginBanner} className="w-100 vh-100 object-fit-cover login-banner" alt="Menard Logo" />
          </Col>
        </Row>
      </Container>
     
    </section>
  );
};

export default ResetPass;
